import React from 'react'
import sumBy from 'lodash/sumBy'
import type { MonthlyThumbsUpReport } from './types'
import css from './thumbsUpTable.css'
import { i18n } from '../../index'
type Props = {
  data: Array<MonthlyThumbsUpReport>
  week: number | string
}

const WeekSummaryRow = ({ data, week }: Props) => (
  <tr className={css.weekRow}>
    <td>{`${i18n.t('common.weekShort')} ${week}`}</td>
    <td>{sumBy(data, 'target').toFixed(0)}</td>
    <td>{sumBy(data, 'actual').toFixed(0)}</td>
  </tr>
)

export default WeekSummaryRow
